import React, { useState } from 'react';

import { Modal } from '@wds/modal';
import { Box } from '@wds/box';
import { Button } from '@wds/button';
import { Typography } from '@wds/typography';

import PropTypes from 'prop-types';
import MFA from '../Authentication/MFA';

import STRINGS from '../../constants';

const ChangeMFADeviceModal = (props) => {
	const {
		open,
		handleClose,
	} = props;

	const [showChangeDevice, setShowChangeDevice] = useState(false);

	const handleOnClose = (completed, method) => {
		handleClose(method);
	};

	const handleChangeDevice = () => {
		setShowChangeDevice(true);
	};

	return (
		<Box id='sma-change-mfa-device-modal'>
			<Modal
				show={open}
				data-testid='change-mfa-device-modal'
				onClose={handleOnClose}
			>
				{!showChangeDevice && (
					<Modal.Header header={STRINGS.changeMFADevice} />
				)}
				<Modal.Body>
					{showChangeDevice && (
						<Box id='sma-mfa-enrollment-modal'>
							<MFA isModal handleClose={handleOnClose} isChange />
						</Box>
					)}
					{!showChangeDevice && (
						<Typography component='p' variant='bodySm'>
							{STRINGS.changeMFADeviceMessage}
						</Typography>
					)}
				</Modal.Body>
				{!showChangeDevice && (
					<Modal.Footer align='right'>
						<Button onClick={() => handleOnClose()} id='sma-cancel-button' aria-label={STRINGS.cancel} variant='text'>
							{STRINGS.cancel}
						</Button>
						<Button onClick={() => handleChangeDevice()} id='sma-change-device-button' aria-label={STRINGS.changeDevice}>
							{STRINGS.changeDevice}
						</Button>
					</Modal.Footer>
				)}
			</Modal>
		</Box>
	);
};

ChangeMFADeviceModal.propTypes = {
	open: PropTypes.bool.isRequired,
	handleClose: PropTypes.func.isRequired,
};

export default ChangeMFADeviceModal;
